import { render, staticRenderFns } from "./CurrencyTable.vue?vue&type=template&id=6d2721c7&"
import script from "./CurrencyTable.vue?vue&type=script&lang=js&"
export * from "./CurrencyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports